import { useMemo as e } from "react";

var n = function n(_ref) {
  var t = _ref.isVisibleDisabled,
      o = _ref.isAlwaysVisible,
      r = _ref.colorsConfig;
  return !t && o ? r.active : r.hidden;
},
    m = function m(_ref2) {
  var t = _ref2.isVisibleDisabled,
      o = _ref2.isAlwaysVisible,
      r = _ref2.colorsConfig;
  return e(function () {
    return n({
      isAlwaysVisible: o,
      isVisibleDisabled: t,
      colorsConfig: r
    });
  }, [o, t, r]);
};

export { m as useControlColor };